<template>
  <svg class="icon" :class="`icon--${size}`">
    <use :xlink:href="`#${name}`"></use>
  </svg>
</template>

<script>
  export default {
    props: {
      name: { type: String },
      size: {
        type: String,
        validator: prop => ['sm', 'md'].indexOf(prop) > -1,
        default: 'md'
      }
    },
  }
</script>

<style lang="scss">
  .icon {
    display: inline-block;
    font-size: inherit;
    width: 1em;
    height: 1em;
    color: currentColor
  }
  .icon--md {
    font-size: 28px;
  }
</style>
